export const partnersConfig = {
  vnn: 'VNN',
  dragonfly: 'DragonFly',
  rankone: 'RankOne',
  rapidreplay: 'RapidReplay',
};
